import request from "../../utils/request";
import { Result } from "../../models/general";
import { EmployeeMovementInput, EmployeeMovementView } from "../../models/employee";

export async function createMovement(input: EmployeeMovementInput) {
    const response = await request.post<Result<EmployeeMovementView>>("EmployeeMovement/Create", input);
    return response.data;
}

export async function getMovementsForEmployee(userId: string) {
    const response = await request.get<Result<EmployeeMovementView[]>>(`EmployeeMovement/GetForEmployee/${userId}`);
    return response.data;
}

export async function getAllMovements() {
    const response = await request.get<Result<EmployeeMovementView[]>>("EmployeeMovement/GetAll");
    return response.data;
}

export async function approveMovement(id: number) {
    const response = await request.post<Result<EmployeeMovementView>>(`EmployeeMovement/Approve/${id}`);
    return response.data;
}

export async function rejectMovement(id: number, reason: string) {
    const response = await request.post<Result<EmployeeMovementView>>(`EmployeeMovement/Reject/${id}`, { rejectionReason: reason });
    return response.data;
}
